<template>
  <BaseModal modalColor="border-success bg-primary" iconModal="fa fa-edit" subtitulo="Cadastrar novo itens da saida"
             col-md="col-md-4" offset="offset-3">
    <template v-slot:modalContent>
      <form ref="cadastroForm" @submit.prevent="submitIncluirForm">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label><strong>Construção: </strong></label>
              <p class="font-bold"> {{ construcaoDesc }}</p>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label><strong>Data da saida: </strong></label>
              <p class="font-bold"> {{ saidaData }}</p>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <FloatLabel variant="on">
                <Select
                    v-model="dado.material"
                    inputId="material"
                    :options="materiais"
                    optionLabel="descricao"
                    optionValue="id"
                    size="small"
                    appendTo="body"
                    filter
                    style="width: 100%"
                    :invalid="campoVazio.includes('material')"
                    @blur="getCompras(dado.material)"
                >
                  <template #emptyfilter>
                    Nenhum resultado encontrado
                  </template>
                </Select>
                <label for="imovel">
                  <strong>Material:</strong> <span class="text-danger font-bold">*</span>
                </label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <FloatLabel variant="on">
                <Select
                    v-model="dado.compra"
                    inputId="compra"
                    :options="compras"
                    :optionLabel="(compra) => `${compra.fornecedor} - ${compra.data_compra} - R$ ${compra.valor_total}`"
                    optionValue="id"
                    size="small"
                    appendTo="body"
                    filter
                    style="width: 100%"
                    :invalid="campoVazio.includes('compra')"
                >
                  <template #emptyfilter>
                    Nenhum resultado encontrado
                  </template>
                </Select>
                <label for="compra">
                  <strong>Compra:</strong> <span class="text-danger font-bold">*</span>
                </label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputNumber id="quantidade" v-model="dado.quantidade" size="small" style="width: 100%"
                             fluid :inputStyle="{ textAlign: 'right' }" :invalid="campoVazio.includes('quantidade')"
                             @update:modelValue="calcularValores"/>
                <label for="quantidade"><strong>Qtd: <span class="text-danger font-bold">*</span></strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputNumber id="valor_unitario" v-model="dado.valor_unitario" size="small"
                             style="width: 100%" :minFractionDigits="2" :maxFractionDigits="5" fluid
                             :inputStyle="{ textAlign: 'right' }"
                             :invalid="campoVazio.includes('valor_unitario')" @update:modelValue="calcularValores"/>
                <label for="valor_unitario"><strong>Valor Unitário: <span
                    class="text-danger font-bold">*</span></strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputNumber id="valor_total" v-model="dado.valor_total" size="small"
                             style="width: 100%" :minFractionDigits="2" :maxFractionDigits="5" fluid
                             :inputStyle="{ textAlign: 'right' }" disabled/>
                <label for="valor_total"><strong>Valor Total: </strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <button type="submit" class="btn btn-primary font-bold">Confirmar</button>
            </div>
          </div>
        </div>
      </form>
      <hr>

      <label><strong>Itens da Saida:</strong></label>
      <div class="table-responsive">
        <table id="table_list" class="table table-striped table-bordered table-hover dataTables-example">
          <thead>
          <tr>
            <th>ID</th>
            <th>COMPRA</th>
            <th>MATERIAL</th>
            <th>QTD</th>
            <th>VALOR UNIT.</th>
            <th>VALOR TOTAL</th>
            <th class="text-center">+</th>
          </tr>
          </thead>
          <tbody class="overflow-auto" style="max-height: 300px">
          <tr v-for="item in dados" :key="item.id" :id="'linha_' + item.key">
            <td class="text-right">{{ item.id }}</td>
            <td>{{ item.compra }}</td>
            <td>{{ item.material }}</td>
            <td class="text-right">{{ item.quantidade }}</td>
            <td class="text-right">{{ item.valor_unitario }}</td>
            <td class="text-right">{{ item.valor_total }}</td>
            <td class="text-center">
              <button class="btn btn-danger btn-xs font-bold" @click="deletarDado(item.key, item.id, item.compra)">
                <i class="fa fa-trash"></i>
              </button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="ibox-footer">
        <button class="btn btn-success font-bold" @click="$emit('fechar')">
          Fechar
        </button>
      </div>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/base/BaseModal.vue';
import {apiRequest, alertDelete} from "../../../../public/js/utils/funcoes";
import {apiUrl} from "@/router/apiBackRoutes";


export default {
  name: "CadastrarSaidaItens",
  components: {
    BaseModal,
  },
  props: {
    itemId: Number,
    construcaoDesc: String,
    saidaData: String,
  },
  emits: ["fechar", "atualizarLista"],
  data() {
    return {
      materiais: [],
      compras: [],
      dados: [],
      dado: {
        saida: this.itemId,
        material: "",
        compra: "",
        quantidade: "",
        valor_unitario: "",
        valor_total: "",
      },
      campoVazio: [],
    }
  },
  methods: {
    atualizarLista(novoDado) {
      this.dados.push(novoDado);
    },
    deletarDado(itemkey, itemId, itemNome) {
      let url = apiUrl.saidas.itensDestroy(itemkey);
      alertDelete(itemkey, url, 'Você deseja deletar o registro?', `ID: ${itemId} | ${itemNome}`, itemkey, url);
    },
    calcularValores() {
      let quantidade = parseFloat(this.dado.quantidade);
      let valorUnitario = parseFloat(this.dado.valor_unitario);

      if (!isNaN(quantidade) && !isNaN(valorUnitario)) {
        this.dado.valor_total = (quantidade * valorUnitario).toFixed(2);
      } else {
        this.dado.valor_total = '0.00';
      }
    },
    async getMateriais() {
      const resultado = await apiRequest("GET", `${apiUrl.materiais.createList}?status=A`);
      if (resultado.success) {
        this.materiais = resultado.data.results;
      } else {
        this.$toastMessage("warn", "Atenção", "Erro ao carregar registro!");
        console.error("Erro ao carregar:", resultado.error);
      }
    },
    async getCompras(material) {
      const resultado = await apiRequest("GET", `${apiUrl.compras.createList}?material=${material}`);
      if (resultado.success) {
        this.compras = resultado.data.results;
      } else {
        this.$toastMessage("warn", "Atenção", "Erro ao carregar registro!");
        console.error("Erro ao carregar:", resultado.error);
      }
    },
    async getDados() {
      const resultado = await apiRequest("GET", `${apiUrl.saidas.itensCreateList}?saida_id=${this.itemId}`);
      if (resultado.success) {
        this.dados = resultado.data;
      } else {
        this.$toastMessage("warn", "Atenção", "Erro ao carregar registro!");
        console.error("Erro ao carregar:", resultado.error);
      }
    },
    async submitIncluirForm() {
      const resultado = await apiRequest("POST", apiUrl.saidas.itensCreateList, this.dado);
      if (resultado.success) {
        this.atualizarLista(resultado.data)
        this.$toastMessage("success", "Registro salvo com sucesso!");
        this.dado = {
          saida: this.itemId,
          material: "",
          compra: "",
          quantidade: "",
          valor_unitario: "",
          valor_total: "",
        };
      } else {
        this.campoVazio = Object.keys(resultado.error);
        if (resultado.error && typeof resultado.error === "object") {
          for (const campo in resultado.error) {
            resultado.error[campo].forEach(msg => {
              this.$toastMessage("error", campo, msg);
            });
          }
        } else {
          this.$toastMessage("warn", "Atenção", "Erro inesperado ao salvar!");
        }
      }
    },
  },
  mounted() {
    this.getMateriais();
    // this.getCompras();
    this.getDados();
  }
}
</script>
